"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupComponentContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const React = __importStar(require("react"));
const Colors = __importStar(require("../colors"));
function UnStyledDiv(props) {
    // biome-ignore lint: -
    const { left, top, myRef } = props, restProps = __rest(props, ["left", "top", "myRef"]);
    return (React.createElement("div", Object.assign({ ref: myRef }, restProps), props.children));
}
exports.PopupComponentContainer = (0, styled_components_1.default)(UnStyledDiv) `
  position: relative;
  top: ${props => props.top}px;
  left: ${props => props.left}px;

  min-width: 220px;

  display: inline-block;
  padding: 10px;
  border: 1px solid ${Colors.searchFilterBorderColor};
  border-radius: 1px;

  box-shadow: 3px 3px 5px #eee;

  background: white;

  h1 {
    text-align: center;
    font-weight: bold;
    color: ${Colors.actionMenuHeaderColor};
    font-size: 17px;

    padding-bottom: 10px;
    border-bottom: 1px solid ${Colors.searchFilterBorderColor};

    display: block;
    position: relative;
  }
`;
//# sourceMappingURL=popup-component-container.js.map